import React from "react";
import { useSelector } from "react-redux";
import { useEditProjectMutation, useGetProjectsQuery } from "../../features/projects/projectApi";
import { useGetTeamsQuery } from "../../features/teams/teamsApi";
import ProjectDetail from "./ProjectDetail";
import { useDrop } from "react-dnd";

export default function ProjectItem({ state, setOpenModal }) {
    const {data: projects} = useGetProjectsQuery();
    const { user: loggedInUser } = useSelector((state) => state.auth) || {};
    const { data: teams } = useGetTeamsQuery(); 
    const [ editProject ] = useEditProjectMutation();

    const userTeams = teams?.filter(team => team.users.find(user => user?.id == loggedInUser.id))?.map(team => team?.id?.toString());
    const userProjects = projects?.filter(proj => proj?.state === state && userTeams?.includes(proj?.teamId));
    
    const handleDropItem = (project) => {
        editProject({
            id: project?.id,
            data: {
                ...project,
                state
            }
        });
    };

    const [{ isOver}, dropRef] = useDrop({
        accept: 'project',
        drop: (item, monitor) => {
            handleDropItem(item?.project);
        },
        collect: (monitor) => ({
            isOver: monitor.isOver()
        })
    });

    return (
            <div className="flex flex-col flex-shrink-0 w-72" ref={dropRef}>
                <div className="flex items-center flex-shrink-0 h-10 px-2">
                    <span className="block text-sm font-semibold">{state}</span>
                    <span
                        className="flex items-center justify-center w-5 h-5 ml-2 text-sm font-semibold text-indigo-500 bg-white rounded bg-opacity-30"
                        >{userProjects?.length || 0}</span
                    >
                    {state === "Backlog" &&
                    <button
                        className="flex items-center justify-center w-6 h-6 ml-auto text-indigo-500 rounded hover:bg-indigo-500 hover:text-indigo-100"
                        onClick={() => setOpenModal(true)}
                    >
                        <svg
                            className="w-5 h-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                            ></path>
                        </svg>
                    </button>
                    }
                </div>
                <div className="flex flex-col pb-2 overflow-auto">

                    {userProjects
                        ?.slice()
                        ?.sort((a ,b) => b?.timestamp - a?.timestamp)
                        ?.map(project => 
                            <ProjectDetail 
                                key = {project.id} 
                                project = {project} 
                            />
                    )}
                </div>
            </div>
    )
}